// extracted by mini-css-extract-plugin
module.exports = {"text":"_99551c8aa8--text--brSnU"};